export const authLoginURI = '/auth/login';
export const authRefreshTokenURI = '/auth/refreshToken';
export const authValidateTokenURI = '/auth/validateToken';
export const userPassCreateURI = '/user-service/user-profile/passCreate';
export const userForgotPasswordURI = '/user-service/user-profile/forgetPassword';
export const userChangePasswordURI = '/user-service/user-profile/changePassword';
